module.exports = __webpack_public_path__ + "media/images/steps/step_19-0da7105b4575859a80c513066675d8a5.svg";